import { render, staticRenderFns } from "./PropertyInfoDialog.vue?vue&type=template&id=48d0ad65&scoped=true"
import script from "./PropertyInfoDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./PropertyInfoDialog.vue?vue&type=style&index=0&id=48d0ad65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0ad65",
  null
  
)

export default component.exports